import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const LighthouseLogoWhite = () => (
  <Image
    src="/assets/images/Final_999-1788818196979.png"
    alt="Harbour Counselling Practice Logo"
    width={169}
    height={80}
    className="object-contain"
  />
);

export default function Footer() {
  return (
    <footer className="bg-[#1B4D4A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Logo & Tagline */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <LighthouseLogoWhite />
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              A safe, compassionate space for your journey towards wellbeing and healing.
            </p>
            <div className="flex gap-3 mt-5">
              {/* Facebook */}
              <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/40 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/harbourcounsellingpractice/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/40 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/>
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-white/40 flex items-center justify-center hover:border-white hover:bg-white/10 transition-all">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-white text-base mb-5 tracking-wide">Contact</h3>
            <div className="space-y-3">
              <a href="tel:+447462291154" className="flex items-center gap-3 text-white/90 text-sm hover:text-white transition-colors no-underline">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                <span>+44 7462 291154</span>
              </a>
              <a href="mailto:contact@harbourcounsellingpractice.com" className="flex items-center gap-3 text-white/90 text-sm hover:text-white transition-colors no-underline">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                <span>contact@harbourcounsellingpractice.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white text-base mb-5 tracking-wide">Quick Links</h3>
            <div className="grid grid-cols-2 gap-2">
              {[
                { href: '/about', label: 'About Melinda' },
                { href: '/services', label: 'Services' },
                { href: '/fees', label: 'Fees' },
                { href: '/resources', label: 'Resources' },
                { href: '/faqs', label: 'FAQs' },
                { href: '/contact', label: 'Contact' },
                { href: '/book', label: 'Book a Session' },
              ]?.map((link) => (
                <Link key={link?.href} href={link?.href} className="text-white/80 text-sm hover:text-white transition-colors">
                  {link?.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 mt-7 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-white/70 text-sm">© 2026 Harbour Counselling Practice. All rights reserved. Powered by <a href="https://qondzo.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">Qondzo</a></p>
          <div className="flex gap-5">
            <Link href="/privacy" className="text-white/70 text-sm hover:text-white transition-colors">Privacy Policy</Link>
            <Link href="/terms" className="text-white/70 text-sm hover:text-white transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
